import React from "react";
import Loadable from "../../react-loadable";

export { showImage } from "./components/Wrapper";

const WeaZmage = Loadable({
  loader: () => import("./Zmage"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaZmage;



// WEBPACK FOOTER //
// ./ecology9/wea-zmage/index.js